// src/component/FormTemplate.js
import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';


export default function FormTemplate() {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id");

    const [formData, setFormData] = useState(false); 
    const [emailValue, setEmailValue] = useState(""); 
    const [fullNameValue, setFullNameValue] = useState(""); 

    useEffect(() => {
      const id = new URLSearchParams(window.location.search).get("uid");
        // 检查 URL 中是否包含 id 参数
        if (id) {
          // 如果有 id 参数，发送 GET 请求到 API

        } else {
            // 如果 id 不存在，重定向到 /home
        }
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
    };

  return (
    <div className="App">
      <Container component="main" maxWidth="xl">
      <Typography variant="h1" sx={{ textAlign: 'center', m: 3,fontSize: '2rem' }}>勞務報酬單</Typography>
      <Typography variant="body1" sx={{ textAlign: 'right', fontSize: '1rem' }}>填表日期：</Typography>
      <Typography variant="body1" sx={{ textAlign: 'right', fontSize: '1rem' }}>支付日期：</Typography>
      
      <Typography variant="h2" sx={{ textAlign: 'left', fontSize: '1.5rem' }}>基本資料</Typography>
      <div style={{ display: 'grid', gridTemplateColumns: "20% 20% 20% 40%"}}>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>姓名</Typography>
        </div>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>彭翊</Typography>
        </div>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>地址</Typography>
        </div>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>台北市中正區北平東路30-2號4樓</Typography>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: "20% 20% 20% 40%"}}>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', pb: '0.5rem', p:1 }}>連絡電話</Typography>
        </div>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>0910266619</Typography>
        </div>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>身分證/護照</Typography>
        </div>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>H124387548</Typography>
        </div>
      </div>

      <Typography variant="h2" sx={{ textAlign: 'left', fontSize: '1.5rem', mt:2 }}>勞務內容</Typography>
      <div style={{ border: '1px solid black'}}>
        <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>勞務內容：</Typography>
      </div>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}>所得類別</Typography>
          <div style={{ textAlign: 'left' }}><Checkbox color="default" />本國籍<Checkbox color="default" />外國籍滿183天</div>
            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 25% 30% 30%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black", pl:1 }}>名稱</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black", pl:1 }}>說明</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black", pl:1 }}>所得人領款計算</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', pl:1 }}>注意事項</Typography>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 25% 30% 30%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default" /></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black", p:1 }}>9B稿費</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black", p:1 }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black", p:1 }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', p:1 }}></Typography>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 25% 30% 30%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default" /></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}>9A執行業務所得</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}></Typography>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 25% 30% 30%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default" /></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}>50薪資所得</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}></Typography>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 25% 30% 30%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default"/></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}>92其他所得</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}></Typography>
            </div>
            <div style={{ textAlign: 'left',mt:2 }}><Checkbox color="default" />外國籍未滿183天，須於10日內申報</div>
            
            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 85%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default"/></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}>9B稿費</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}></Typography>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 85%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default"/></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}>9A執行業務所得</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}></Typography>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 85%",border: '1px solid black', marginRight:"20px", marginLeft:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default"/></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}>50薪資所得</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}></Typography>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: "5% 10% 85%",border: '1px solid black', marginRight:"20px", marginLeft:"20px", marginBottom:"20px"}}>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}><Checkbox color="default"/></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}>92其他所得</Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem', borderRight:"1px solid black" }}></Typography>
              <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}></Typography>
            </div>
        </div>

        <Typography variant="h2" sx={{ textAlign: 'left', fontSize: '1.5rem', mt:2 }}>領款金額</Typography>
        <div style={{ display: 'grid', gridTemplateColumns: "50% 50%",border: '1px solid black', marginBottom:"20px"}}>
          <div style={{borderRight:"1px solid black", padding:"0.5rem"}}>
            <Typography variant="h4" sx={{ textAlign: 'left', fontSize: '1rem'}}>支領金額：</Typography>
            <Typography variant="h4" sx={{ textAlign: 'left', fontSize: '1rem'}}>所得稅額：</Typography>
            <Typography variant="h4" sx={{ textAlign: 'left', fontSize: '1rem'}}>二代健保：</Typography>
            <Typography variant="h4" sx={{ textAlign: 'left', fontSize: '1rem'}}>支付淨額：</Typography>
          </div>
          <div>
          <Typography variant="h4" sx={{ textAlign: 'left', fontSize: '1rem',p:1}}>領款人</Typography>
          </div>
        </div>
        <Typography variant="body1" sx={{ textAlign: 'right', fontSize: '1rem' }}>經辦人：</Typography>
        <div style={{ border: '1px solid black'}}>
          <Typography variant="body1" sx={{ textAlign: 'center', fontSize: '1rem' }}>身分證/護照影本黏貼處：</Typography>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: "50% 50%",border: '1px solid black'}}>
          <div style={{borderRight:"1px solid black"}}>
            <Typography variant="body1" sx={{ textAlign: 'center', fontSize: '1rem'}}>正面</Typography>
          </div>
          <div >
          <Typography variant="body1" sx={{ textAlign: 'center', fontSize: '1rem'}}>領款人</Typography>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: "50% 50%",border: '1px solid black'}}>
          <div style={{borderRight:"1px solid black",paddingTop:"150px"}}></div>
          <div ></div>
        </div>
        <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}>註1：本表為網路申報作業，紙本僅供存檔參考。</Typography>
        <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}>註2：若本表資料有誤，請聯繫MasterAccounting異動處理。</Typography>
        <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}>下載時間：</Typography>
        <Typography variant="body1" sx={{ textAlign: 'left', fontSize: '1rem' }}>技術提供：內容電力股份有限公司</Typography>
      </Container>
    </div>
  );
}